module.exports = __webpack_public_path__ + "img/img_zixun.d7ec0498.jpg";